export default __webpack_public_path__ + "static/media/slogen.ef4ca06c.png";